import './styles.scss';

export enum AppInfoBlockSize {
    SMALL = '',
    MEDIUM = 'medium',
    BIG = 'big',
}

export enum AppInfoBlockView {
    DEFAULT = '',
    COLORED = 'colored',
}

export interface IAppInfoBlock {
    label: string;
    value: string;
    highlighted?: boolean;
}

interface AppInfoBlockProps extends IAppInfoBlock {
    size?: AppInfoBlockSize;
    view?: AppInfoBlockView;
}

export const AppInfoBlock = ({
    label,
    value,
    highlighted = false,
    size = AppInfoBlockSize.SMALL,
    view = AppInfoBlockView.DEFAULT,
}: AppInfoBlockProps) => {
    return (
        <div className={`app-info-block ${size} ${view} ${highlighted ? 'highlighted' : ''}`}>
            <div className='app-info-block__label'>{label}</div>
            <div className='app-info-block__value'>{value}</div>
        </div>
    );
};
